import React from 'react'
import { BaseCard } from './BaseCard'
import { APIClient } from '@/services'
import { OrganisationSelect } from '@/components'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'

export const OrganizationCard = ({ item }: RenderItemProps) => {
  const { profile } = APIClient.Session.useSession()

  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <OrganisationSelect
        loadInitialValue
        {...prompt.form.register('organization')}
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
      />
    </BaseCard>
  )
}
